import React, { useCallback, useState } from "react";

import { Button } from "primereact/button";
import DatasetSelection from "./DatasetSelection";
import DatasetView from "./DatasetView";
import { Dataset } from "./models/types";
import { removeItemById } from "./utils/utils";
import "./styles/style.scss";
import { CurrentLineConfig } from "./DatasetLineConfigOptions";

export default function DatasetWindow() {
  const [selectedDatasets, setSelectedDatasets] = useState<Array<Dataset>>([]);
  const [selectionPanel, setSelectionPanel] = useState<boolean>(true);

  const removeDataset = useCallback(
    (removedId: string | string[]) => {
      if (typeof removedId === "string") {
        setSelectedDatasets(removeItemById(selectedDatasets, removedId));
      }
      if (Array.isArray(removedId)) {
        setSelectedDatasets(prev => prev.filter(dataset => !removedId.includes(dataset.identifier)));
      }
    },
    [selectedDatasets]
  );

  const setCurrentLineConfig = (identifier: string, currentLineConfig: CurrentLineConfig) => {
    const newSelectedDatasets = selectedDatasets.map(dataset => {
      if (dataset.identifier === identifier) {
        return { ...dataset, currentLineConfig };
      }
      return dataset;
    });
    setSelectedDatasets(newSelectedDatasets);
  };

  return (
    <div className="windowSplit">
      {selectionPanel ? (
        <Button
          icon="pi pi-chevron-left"
          className="toggleButton p-button p-button-text"
          onClick={() => setSelectionPanel(false)}
        />
      ) : (
        <Button
          icon="pi pi-chevron-right"
          className="toggleButton collapsed p-button p-button-text"
          onClick={() => setSelectionPanel(true)}
        />
      )}
      <div style={{ display: "inline" }}>
        {selectionPanel && (
          <div className="datatable  horizontal">
            <DatasetSelection
              datasets={selectedDatasets}
              setDatasets={setSelectedDatasets}
              useSearchParameters
            />
          </div>
        )}
      </div>

      <DatasetView
        selectedDatasets={selectedDatasets}
        setSelectedDatasets={setSelectedDatasets}
        removeDataset={removeDataset}
        setCurrentLineConfig={setCurrentLineConfig}
      />
    </div>
  );
}
